import _ from 'lodash'
import { TextListGroupValue } from 'particles/TextInputs/TextList/Group'

export const interpolate = (str: string, values: Record<string, any>): string => {
    return str.replace(/{{(\w+)}}/g, (match, key) => {
        const valuesKey = Object.keys(values)
        return valuesKey.includes(key) ? values[key] : match
    })
}

export const templateTransList = (
    placeholderList: string[],
    keyValueMap: { key: string; value: string; emptyValue: string }[],
) => {
    const keyValueDict: Record<string, string> = Object.fromEntries(
        keyValueMap.map(({ key, value, emptyValue }) => [key, _.isEmpty(value) ? emptyValue : value]),
    )

    return placeholderList.map(placeholder => interpolate(placeholder, keyValueDict))
}

export const interpolateAndJoin = (
    placeholderList: string[],
    options: { keyValueMap?: any; hideBulletPoint?: boolean } = {},
) => {
    const { keyValueMap, hideBulletPoint } = options
    const interpolatedList = keyValueMap ? templateTransList(placeholderList, keyValueMap) : placeholderList
    return hideBulletPoint
        ? interpolatedList.join('\n')
        : interpolatedList.map(placeholderList => '\u2022  ' + placeholderList).join('\n')
}

interface FormatOptions {
    isList?: boolean
    isNumberedList?: boolean
    bulletPoint?: string
    prefix?: string
    valueKey?: string // Option to specify which key to use if 'values' is a nested object
    concatSymbol?: string
}

export const formatTaskValues = (
    values: TextListGroupValue[] | Record<string, any> | undefined,
    options: FormatOptions = {},
): string => {
    const {
        isList = true,
        isNumberedList = false,
        bulletPoint = '',
        prefix = '',
        valueKey = 'name',
        concatSymbol = ' ',
    } = options

    if (
        !Array.isArray(values) ||
        values.length === 0 ||
        (values.length === 1 && !getValueString(values[0], valueKey))
    ) {
        return ''
    }

    const lineBreak = isList ? '\n' : concatSymbol

    return values.reduce((acc, item, index, array) => {
        const valueString = getValueString(item, valueKey)
        const listMarker = isNumberedList ? `${index + 1}.` : bulletPoint
        if (valueString) {
            const formattedString = listMarker ? `${listMarker}  ${prefix}${valueString}` : `${prefix}${valueString}`
            return acc + formattedString + (index === array.length - 1 ? '' : lineBreak)
        }
        return acc
    }, '')
}

function getValueString(item: TextListGroupValue, valueKey: string): string | undefined {
    if (typeof item?.value === 'string') {
        return item.value
    } else if (typeof item?.value === 'object' && item.value !== null) {
        return (item.value[valueKey] as string)?.toString()
    }
    return undefined
}

export const formatTextListGroupValueArray = (array: TextListGroupValue[], prefix: string) => {
    const formattedValues = array
        .filter((item): item is { uuid: string; value: string } => item !== undefined && item.value !== '')
        .map(item => `${prefix}${item.value}`)
        .join(' ')
    return formattedValues
}

// Function to remove items containing a specific substring and format the result as TextListGroupValue
export const removeAndFormatTagsValue = (array: string[], substring: string): TextListGroupValue[] => {
    return array
        .filter(item => !item.includes(substring))
        .map((item, index) => ({ uuid: index.toString(), value: item }))
}
